/*
Copyright Amazon.com, Inc. or its affiliates. All Rights Reserved.

Licensed under the Apache License, Version 2.0 (the "License").
You may not use this file except in compliance with the License.
You may obtain a copy of the License at

    http://www.apache.org/licenses/LICENSE-2.0

Unless required by applicable law or agreed to in writing, software
distributed under the License is distributed on an "AS IS" BASIS,
WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
See the License for the specific language governing permissions and
limitations under the License.
*/

import AppRouter from "Router";
import Footer from "components/layout/footer";
import LHeader from "components/layout/header";
import React from "react";

export interface SignedInAppProps {
  oidcSignOut?: () => void;
}
const SignedInApp: React.FC<SignedInAppProps> = (props: SignedInAppProps) => {
  return (
    <div className="App">
      <LHeader oidcSignOut={props.oidcSignOut} />
      <AppRouter />
      <footer className="lh-footer">
        <Footer />
      </footer>
    </div>
  );
};

export default SignedInApp;
